var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 0.1875H0.8125C0.466797 0.1875 0.1875 0.466797 0.1875 0.8125V15.1875C0.1875 15.5332 0.466797 15.8125 0.8125 15.8125H15.1875C15.5332 15.8125 15.8125 15.5332 15.8125 15.1875V0.8125C15.8125 0.466797 15.5332 0.1875 15.1875 0.1875ZM5.1875 12.5312C5.1875 12.6172 5.11719 12.6875 5.03125 12.6875H3.46875C3.38281 12.6875 3.3125 12.6172 3.3125 12.5312V3.46875C3.3125 3.38281 3.38281 3.3125 3.46875 3.3125H5.03125C5.11719 3.3125 5.1875 3.38281 5.1875 3.46875V12.5312ZM8.9375 7.0625C8.9375 7.14844 8.86719 7.21875 8.78125 7.21875H7.21875C7.13281 7.21875 7.0625 7.14844 7.0625 7.0625V3.46875C7.0625 3.38281 7.13281 3.3125 7.21875 3.3125H8.78125C8.86719 3.3125 8.9375 3.38281 8.9375 3.46875V7.0625ZM12.6875 8.46875C12.6875 8.55469 12.6172 8.625 12.5312 8.625H10.9688C10.8828 8.625 10.8125 8.55469 10.8125 8.46875V3.46875C10.8125 3.38281 10.8828 3.3125 10.9688 3.3125H12.5312C12.6172 3.3125 12.6875 3.38281 12.6875 3.46875V8.46875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.425b605b8db5a3d647b14167855e5ea7.svg";
export { ForwardRef as ReactComponent };